import { render, staticRenderFns } from "./AdminClub.vue?vue&type=template&id=68317255&scoped=true&"
import script from "./AdminClub.vue?vue&type=script&lang=js&"
export * from "./AdminClub.vue?vue&type=script&lang=js&"
import style0 from "./AdminClub.vue?vue&type=style&index=0&id=68317255&lang=less&scoped=true&"
import style1 from "./AdminClub.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68317255",
  null
  
)

export default component.exports